module.exports = __webpack_public_path__ + "media/images/close-d9d2d0b1308cb694aa8116915592e2a9.png";